export enum ClientOutputType {
  Email = 0,
  MobileApp = 1,
}
